import { useEffect, useState } from "react";

import { useTitles } from "../../../../Recoil/Novel/Title";
import { useEpisodes } from "../../../../Recoil/Novel/Episode";

import { ContentsType, readContents } from "../../../../Data/Novel/Contents";

import EpubViewer from "./Component/EpubViewer";
import EpisodeInformation from "./Component/EpisodeInformation";
import EpisodeFooter from "./Component/EpisodeFooter";

import './index.scss';
import UIGroup from "./Component/UIGroup";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { fn } from "../../../../Functions";
import LoadingCircle from "../../../../Components/LoadingCircleAnimated";
import { isAxiosError } from "axios";
import { useToastAlert } from "@webtoontoday/toast";

const EpisodeHome = ({
    serviceId, titleId, episodeId, snapshotId,
    query, hash, isClient
}: {
    serviceId?: string, titleId?: string, episodeId?: string, snapshotId?: string,
    query: string, hash: string, isClient: any
}) => {
    const [isBarVisible, setIsBarVisible] = useState(true);
    const [isPayAsking, setIsPayAsking] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [ content, setContent ] = useState<ContentsType | null>(null);

    const { fetch: fetchTitle, titleObject } = useTitles();
    const { fetch: fetchEpisode, episodeObject } = useEpisodes();
    const { toastAlert } = useToastAlert();

    const title = titleObject[`${serviceId}:${titleId}`];

    const episodes = episodeObject[`${serviceId}:${titleId}`];
    const episode = (episodes || []).length > 0 ? episodes.find( episode => episode.episodeId === content?.data?.episodeId ) : undefined;

    useEffect(()=>{
        if (!serviceId || !titleId) return;
       
        fetchTitle([{serviceId, titleId}]);
        fetchEpisode({serviceId, titleId});

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[serviceId, titleId]);

    useEffect(()=>{
        if ( !serviceId || !titleId || !episodeId ) return;

        (async()=>{
            try {
                setIsLoading(true);
                const contentRes = await readContents(serviceId, titleId, episodeId);
                setIsLoading(false);
                if ( !contentRes ) return;
                setContent(contentRes);
                
                localStorage.setItem(`contents:${serviceId}:${titleId}:${episodeId}`, Math.floor(Date.now() / 1000).toString());
            } catch(e) {
                setIsLoading(false);
                if (isAxiosError(e) && e.status === 429) {
                    toastAlert({iconType:"error", message:"최근 10분 동안 너무 많은 요청이 발생했습니다. \n잠시 후 다시 시도해주세요."});
                }
                console.error(e)
            }
        })();
    },[serviceId, titleId, episodeId, toastAlert])

    useEffect(() => {
        const barVisibilityControl = () => {
            if (!isBarVisible) return;
            setIsBarVisible(false);
        };

        window.addEventListener('scroll', barVisibilityControl);

        return () => {
            window.removeEventListener('scroll', barVisibilityControl);
        };
    }, [isBarVisible]);

    if (!(serviceId || titleId || episodeId)) {
        return <></>;
    }

    return (<div className={"EpisodeHomeArea"}
        onClick={(e) => {setIsBarVisible(!isBarVisible)}}
    >
      
        {title && episodeId === "000001"
            && <EpisodeInformation title={title} />}

        {content?.data?.data 
            && <EpubViewer dataUrl={content?.data?.data[0]} />}

        {title && episode 
            && <EpisodeFooter {...{title, episode, setIsPayAsking}} />}
        {serviceId && titleId && episodeId
            && <UIGroup {...{
                serviceId, titleId, episodeId,
                isBarVisible, onClose: () => setIsBarVisible(false),
                setIsPayAsking
            }} />}
        <Dialog className={"PayAskingDialog"} open={isPayAsking} onClose={() => setIsPayAsking(false)} >
            <DialogTitle className={"DialogHeader"}>{"열람권이 필요한 회차"}</DialogTitle>
            <DialogContent className={"DialogBody"}>
                {"해당 회차는 유료 회차로\n 열람권 구매가 필요합니다."}
            </DialogContent>
            <DialogActions className={"DialogActions"}>
                <Button variant={"contained"} fullWidth disableElevation
                    onClick={fn.gotoByAnchor} href={`/payment/${serviceId}/${titleId}`}
                >
                    {"구매 페이지로 이동"}
                </Button>
                <Button fullWidth onClick={() => setIsPayAsking(false)} >
                    {"취소"}
                </Button>
            </DialogActions>
        </Dialog>
        <LoadingCircle show={isLoading} />
    </div>
    )
}

export default EpisodeHome;